const data = {
	alertIcon: 'Wantcpanel',
	alertTitle: 'Compare Plans',
	alertMessage:
		'HostJane partners with AWS, the world\'s safest and most reliable public cloud — with steep discounts.',
};

export default data;
